import { Outlet, useLocation, useNavigate } from "react-router-dom";
import UserRegistrationNavbar from "../UserRegistrationNavbar/UserRegistrationNavbar";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../../../store/state-slices/auth";
import useApiHttp from "../../../hooks/use-http";
import { optionalFaceDetectionIdList } from "../../../util/helper";

const pingDomain = process.env.REACT_APP_PING_DOMAIN;

const UserRegistrationAuthLayout = () => {
  const navigate = useNavigate()
  const [isPageVisible, setIsPageVisible] = useState(true);
  const dispatch = useDispatch();
  const vendorEventId = localStorage.getItem("eventJWT")
  const params = new URLSearchParams(useLocation().search);
  const eventId = params.get("eventId");
  console.log(eventId)

  const { sendRequest: getProfileDetails, isLoading: isProfileLoading } =
    useApiHttp();
  const { sendRequest: getEventDetails, isLoading: eventDetailsLoading } =
    useApiHttp();

  const getEventDetailsApiHandler = () => {
    getEventDetails(
      {
        url: `event/get-event/${eventId}`,
        method: "GET",
      },
      null,
      (data) => {
        dispatch(authActions.setLoginDetails(data?.data))
      }
    )
  }

  const getProfileDetailsApiHandler = () => {
    getProfileDetails(
      {
        base: "AUTH",
        url: `profile`,
        method: "GET",
      },
      null,
      (data) => {
        localStorage.profilePictureThumbnail =
          data?.data?.profilePictureThumbnailUrl;
        localStorage.firstName = data?.data?.firstName;
        localStorage.lastName = data?.data?.lastName;
        localStorage.email = data?.data?.email;
        localStorage.userType = data?.data?.userType
        const isOptionalId =
          optionalFaceDetectionIdList.findIndex(
            (val) => val === data?.data?.email
          ) > -1;
        dispatch(authActions.setLoginDetails(data?.data))
        if (data?.data?.profilePictureThumbnailUrl || isOptionalId) {
          navigate(`/user-registered/photos?eventId=${eventId}`, { replace: true });
        }

      },
      (_, err) => { }
    );
  }

  useEffect(() => {
    const dcCode = localStorage.getItem("dcCode");
    const url = `https://${dcCode}-${pingDomain}/nms/ping`;
    const pingApi = async () => {
      try {
        const response = await fetch(url, {
          headers: {
            "X-Api-Key": process.env.REACT_APP_APIKEY,
            "Content-Type": "application/json",
          },
          credentials: "include",
        });
        if (!response.ok) {
          if (response.status === 401) {
            localStorage.clear();
            window.location.href = vendorEventId ? `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/webview?id=JITOGUEST&eventJWT=${vendorEventId}` : `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/sign-up?event_id=${eventId}`;
          }
          throw new Error("Ping failed with status: " + response.statusText);
        }
      } catch (error) {
        console.error("Error in pingApi:", error);
      }
    };

    const pingInterval = setInterval(() => {
      if (isPageVisible) {
        pingApi();
      }
      console.log("hello time interval");
    }, 30000);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        setIsPageVisible(false);
      } else {
        setIsPageVisible(true);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      clearInterval(pingInterval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isPageVisible]);

  useEffect(() => {
    if (localStorage.authToken && localStorage.refreshToken) {
      dispatch(authActions.setLogin());
    } else {
      // window.location.href = `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/waves?event_id=${localStorage.getItem('eventId')}`;
    }
  }, []);

  useEffect(() => {
    getProfileDetailsApiHandler()
    getEventDetailsApiHandler()
  }, [])
  return (
    <>
      <UserRegistrationNavbar />
      <Box
        sx={{
          p: "50px 0",
          // maxWidth: "360px",
          // minHeight: "calc(100vh)",
          margin: "0 auto",
          // backgroundColor: "#54086E",
          '@media screen and (min-width: 768px)': {
            p: "92px 0 32px",
            maxWidth: "360px",
          }
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};
export default UserRegistrationAuthLayout;
